import client from "services/client";

export const get = async (accessToken) => {
  client.accessToken = accessToken;

  return await client.get("/profile").catch((error) => error);
};

export default { get };
